import { Navigate, Outlet, useParams } from 'react-router-dom';
import { useRole } from '../hooks/useRole';

/**
 * Deja fuera a quien no es personal del centro.
 *
 * `instructor` entra aquí junto a `client`: la API solo le abre `/teaching`, así
 * que sin esto vería el armazón de la aplicación entera y un 403 detrás de cada
 * pantalla, que parece una avería y no una falta de permiso.
 */
const ProtectedOperatorRoute = () => {
  const { isClient, isInstructor } = useRole();
  const { tenantCode } = useParams<{ tenantCode: string }>();

  if (isClient) {
    return <Navigate to={`/${tenantCode}/mi-calendario`} replace />;
  }

  if (isInstructor) {
    return <Navigate to={`/${tenantCode}/mis-clases`} replace />;
  }

  return <Outlet />;
};

export default ProtectedOperatorRoute;
